/**************************************************************************************************************************
 Copyright (c) 2022 WorkEarly Results LLP

     NAME: burger-button.tsx
   AUTHOR: Harikrishnan Gangadharan
 COMMENTS: 

/***************************************************************************************************************************
 STANDARD IMPORTS
****************************************************************************************************************************/
import type { FunctionComponent } from 'react';
/***************************************************************************************************************************
 TYPES / GLOBAL DEFINITIONS
****************************************************************************************************************************/
type BurgerButtonProps = {
    open: boolean,
    toggleMenu: (args: any) => void
}
/***************************************************************************************************************************
 CLASSES / FUNCTIONS
****************************************************************************************************************************/
const BurgerButton: FunctionComponent<BurgerButtonProps> = ({ open, toggleMenu}: BurgerButtonProps) => {
    const commonSpanStyle = "absolute w-[70%] h-[3px] bg-black rounded-sm transition-all duration-500m";

    return (
        <div
        className={`lg:hidden absolute top-0 left-0 w-[48.25px] h-[97.8px] bg-theme-900 flex items-center justify-center shadow-md drop-shadow-md cursor-pointer rounded-tr-[15px] ${!open && 'rounded-br-[15px]'} overflow-hidden`}
        onClick={toggleMenu}>
            <span className={`${commonSpanStyle} ${open && "translate-x-[60px]"}`}></span>
            <span className={`${commonSpanStyle} ${!open?"translate-y-[-7px] w-[40%] left-[15%]":"w-[70%] translate-y-0 rotate-45"}`}></span>
            <span className={`${commonSpanStyle} ${!open?"translate-y-[7px] w-[30%] left-[15%]":"w-[70%] translate-y-0 -rotate-45"}`}></span>
        </div>
    );
}

export default BurgerButton;